import { useDialog } from "@/client/stores/dialog";
import { t } from "@lingui/macro";
import { FilterBonusRefType, FilterResumeType } from "@reactive-resume/dto";
import {
  Button,
  Dialog,
  DialogContent,
  DialogFooter,
  DialogHeader,
  DialogTitle,
  Form,
  FormField,
  FormItem,
  FormLabel,
  Input,
  Select,
  SelectContent,
  SelectGroup,
  SelectItem,
  SelectLabel,
  FormControl,
  SelectValue,
  SelectTrigger,
  ScrollArea,
} from "@reactive-resume/ui";
import { useRef } from "react";
import { useForm } from "react-hook-form";
import { SelectFormField } from "@/client/pages/admin/dashboard/_components/select-form-fields";
import { useFilterResumeStore } from "@/client/stores/filter-resume";
import { usefilterUser } from "@/client/services/user/filter-user";
import { Role, TypeCoupon } from "@reactive-resume/utils";
import { useFilterBonusRef, useFilterCoupon } from "@/client/stores/filter";
import { FilterCouponType } from "libs/dto/src/coupon";
import { useRate } from "@/client/services/rate/rate";
import { useRates } from "@/client/services/rate/rates";
import { useUser } from "@/client/services/user";

type StringFilterCondition = "startsWith" | "contains" | "equals" | "endsWith";
type DateFilterCondition = "gt" | "gte" | "equals" | "lt" | "lte";
type NumberFilterCondition = "gt" | "gte" | "equals" | "lt" | "lte";
export type CouponAmbaFormType = {
  code?: {
    condition: StringFilterCondition;
    value: string;
  };
  reduction?: {
    condition: NumberFilterCondition;
    value: number | undefined;
  };
  userId?: {
    condition: StringFilterCondition;
    value: string;
  };
  startDate?: {
    condition: DateFilterCondition;
    value: string;
  };
  endDate?: {
    condition: DateFilterCondition;
    value: string;
  };
  type?: {
    condition: NumberFilterCondition;
    value: number;
  };
  status?: {
    condition: NumberFilterCondition;
    value: number;
  };
};

const ObjectConversionToFilterType = (object: CouponAmbaFormType) => {
  const filter: FilterCouponType = {};
  Object.entries(object).forEach(([key, field]) => {
    if (!field || field.value == null || Number.isNaN(field.value) || field.value === "") return;

    filter[key as keyof CouponAmbaFormType] = {
      [field.condition]: field.value,
    };
  });
  return filter;
};

export const FilterCouponAmbaDialog = () => {
  type FormValue = CouponAmbaFormType;

  const formRef = useRef<HTMLFormElement>(null);
  const { replaceFilter } = useFilterCoupon();
  const { user } = useUser();
  let { open, isOpen, mode, close } = useDialog("filter-amba-coupon");
  const form = useForm<FormValue>({
    defaultValues: {
      code: {
        condition: "equals",
        value: "",
      },
      reduction: {
        condition: "equals",
        value: undefined,
      },
      userId: {
        condition: "equals",
        value: user!.id,
      },
      startDate: {
        condition: "equals",
        value: "",
      },
      endDate: {
        condition: "equals",
        value: "",
      },
      type: {
        condition: "equals",
        value: TypeCoupon.Promo,
      },
      status: {
        condition: "equals",
        value: undefined,
      },
    },
  });
  const OnSubmit = (data: FormValue) => {
    try {
      data.userId!.condition = "equals";
      data.type!.condition = "equals";
      data.status!.condition = "equals";

      data.type!.value = Number(data.type!.value);
      if (data.reduction!.value) data.reduction!.value = Number(data.reduction!.value);
      if (!Number.isNaN(data.status!.value)) data.status!.value = Number(data.status!.value);

      console.log(data);
      const filter = ObjectConversionToFilterType(data);
      console.log(filter);
      replaceFilter(filter);
      form.reset();
      close();
    } catch {
      form.reset();
    }
  };

  return (
    <Dialog open={isOpen} onOpenChange={close}>
      <DialogContent>
        <DialogHeader>
          <DialogTitle>Filtrer les coupons</DialogTitle>
        </DialogHeader>
        <Form {...form}>
          <form
            ref={formRef}
            onSubmit={form.handleSubmit(OnSubmit)}
            className="flex flex-col gap-y-4"
          >
            <div className="flex flex-row gap-2">
              <div className="flex w-1/2 flex-col gap-2">
                <SelectFormField
                  label={t`Statut`}
                  form={form}
                  condition="String"
                  nameField="status.condition"
                  disabled={true}
                />
                <FormField
                  name="status.value"
                  render={({ field }) => (
                    <FormItem className="w-full">
                      <Select
                        value={field.value}
                        onValueChange={(value) => {
                          field.onChange(value);
                        }}
                      >
                        <FormControl>
                          <SelectTrigger className="w-full">
                            <SelectValue placeholder="Choisir le status" />
                          </SelectTrigger>
                        </FormControl>
                        <SelectContent>
                          <SelectGroup>
                            <SelectLabel>Choisir le status</SelectLabel>
                            <SelectItem value="0"> Actif</SelectItem>
                            <SelectItem value="1"> Inactif</SelectItem>
                          </SelectGroup>
                        </SelectContent>
                      </Select>
                    </FormItem>
                  )}
                />
              </div>
            </div>
            <div className="flex flex-row gap-2">
              <div className="flex w-1/2 flex-col gap-2">
                <SelectFormField
                  label="Code"
                  form={form}
                  condition="String"
                  nameField="code.condition"
                />
                <Input {...form.register("code.value")} />
              </div>
              <div className="flex w-1/2 flex-col gap-2">
                <SelectFormField
                  label="Reduction"
                  form={form}
                  condition="Number"
                  nameField="reduction.condition"
                />
                <Input {...form.register("reduction.value")} type="number" />
              </div>
            </div>
            <div className="flex flex-row gap-2">
              <div className="flex w-1/2 flex-col gap-2">
                <SelectFormField
                  label="Debute le"
                  form={form}
                  condition="Date"
                  nameField="startDate.condition"
                />
                <Input {...form.register("startDate.value")} type="date" />
              </div>
              <div className="flex w-1/2 flex-col gap-2">
                <SelectFormField
                  label="Expire le"
                  form={form}
                  condition="Date"
                  nameField="endDate.condition"
                />
                <Input {...form.register("endDate.value")} type="date" />
              </div>
            </div>

            <div className="flex justify-center gap-x-3">
              <Button type="submit" className="bg-moncvpro-secondary">
                {t`Valider`}
              </Button>
            </div>
          </form>
        </Form>
      </DialogContent>
      <DialogFooter></DialogFooter>
    </Dialog>
  );
};
